<template>
  <v-menu
    bottom
    offset-y
    :close-on-content-click="false"
    max-width="320"
  >
    <template v-slot:activator="{ on, attrs }">
      <button
        v-bind="attrs"
        v-on="on"
        class="module-switcher-btn"
        :class="{ 'compact': compact }"
        :disabled="trocandoModulo"
      >
        <v-progress-circular
          v-if="trocandoModulo"
          indeterminate
          size="20"
          width="2"
          color="white"
        ></v-progress-circular>
        <template v-else>
          <v-icon v-if="compact" color="white" size="24">mdi-view-module</v-icon>
          <template v-else>
            <v-icon color="white" size="20" class="mr-2">mdi-view-module</v-icon>
            <span class="module-switcher-text">
              {{ moduloAtualNome || 'Selecionar Módulo' }}
            </span>
            <v-icon color="white" size="18" class="ml-1">mdi-chevron-down</v-icon>
          </template>
        </template>
      </button>
    </template>

    <v-card>
      <v-card-title class="module-switcher-title">
        <v-icon class="mr-2" color="primary">mdi-view-module</v-icon>
        Módulos
      </v-card-title>
      
      <v-divider></v-divider>

      <!-- Módulo Ativo -->
      <div v-if="moduloAtualDetalhes" class="pa-3 module-active-info">
        <div class="text-caption text--secondary mb-1">Módulo Ativo</div>
        <div class="d-flex align-center">
          <v-icon color="success" size="18" class="mr-2">mdi-check-circle</v-icon>
          <div>
            <div class="font-weight-bold">{{ moduloAtualDetalhes.nome }}</div>
            <div class="text-caption" v-if="roleAtivo">
              <!-- <v-chip x-small color="primary" outlined class="mt-1">
                {{ roleAtivo }}
              </v-chip> -->
            </div>
          </div>
        </div>
      </div>

      <v-divider v-if="moduloAtualDetalhes"></v-divider>

      <!-- Lista de Módulos -->
      <v-list dense>
        <v-subheader v-if="modulosDisponiveis.length > 0">
          Módulos Disponíveis
        </v-subheader>

        <v-list-item
          v-for="modulo in modulos"
          :key="modulo.id"
          @click="trocarParaModulo(modulo)"
          :disabled="!modulo.has_access || modulo.id == moduloAtivo"
          class="module-item"
        >
          <v-list-item-icon>
            <v-icon 
              :color="modulo.id == moduloAtivo ? 'success' : (modulo.has_access ? 'grey' : 'grey lighten-2')"
            >
              {{ modulo.icon || 'mdi-layers-outline' }}
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title 
              :class="{ 'font-weight-bold': modulo.id == moduloAtivo }"
            >
              {{ modulo.nome }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="modulo.has_access && modulo.role">
              <v-chip x-small color="grey" outlined>{{ modulo.role }}</v-chip>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="!modulo.has_access" class="text--disabled">
              Sem acesso
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action v-if="modulo.id == moduloAtivo">
            <v-icon color="success" size="20">mdi-check</v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-list-item v-if="modulos.length === 0 && !carregandoModulos">
          <v-list-item-content>
            <v-list-item-title class="text-center text--disabled">
              Nenhum módulo disponível
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <!-- Ações -->
      <v-card-actions>
        <v-btn
          text
          small
          color="primary"
          @click="irParaSelecionarModulo"
        >
          <v-icon small class="mr-1">mdi-view-dashboard</v-icon>
          Ver todos
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ModuleSwitcherComponent',

  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('ctrlModulos', [
      'modulos',
      'moduloAtivo',
      'carregandoModulos',
      'trocandoModulo',
      'moduloAtualDetalhes'
    ]),
    ...mapGetters('login', ['usuarioLogado']),

    moduloAtualNome() {
      return this.moduloAtualDetalhes?.nome || null;
    },

    roleAtivo() {
      return this.usuarioLogado?.role_ativo || null;
    },

    modulosDisponiveis() {
      return this.modulos.filter(m => m.has_access);
    }
  },

  async created() {
    // Carregar módulos se ainda não foram carregados
    if (this.modulos.length === 0) {
      await this.buscarModulos();
    }
  },

  methods: {
    ...mapActions('ctrlModulos', ['buscarModulos', 'trocarModulo']),

    async trocarParaModulo(modulo) {
      if (!modulo.has_access || modulo.id == this.moduloAtivo) {
        return;
      }

      try {
        const response = await this.trocarModulo(modulo.id);
        
        if (response?.status === 200) {
          this.$toast?.success(`Módulo "${modulo.nome}" ativado com sucesso!`);
        } else {
          this.$toast?.error(response?.data?.message || 'Erro ao trocar módulo');
        }
      } catch (error) {
        console.error('Erro ao trocar módulo:', error);
        this.$toast?.error('Erro ao trocar módulo');
      }
    },

    irParaSelecionarModulo() {
      this.$router.push('/selecionar-modulo');
    }
  }
};
</script>

<style scoped>
.module-switcher-btn {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 40px;
}

.module-switcher-btn:hover:not(:disabled) {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.module-switcher-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.module-switcher-btn.compact {
  padding: 8px;
  min-width: 40px;
  justify-content: center;
}

.module-switcher-text {
  color: white;
  font-size: 14px;
  font-weight: 500;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.module-switcher-title {
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
}

.module-active-info {
  background-color: #f5f5f5;
}

.module-item {
  cursor: pointer;
}

.module-item:hover:not(.v-list-item--disabled) {
  background-color: rgba(0, 0, 0, 0.04);
}

.v-list-item--disabled {
  opacity: 0.5;
}
</style>
